import React from 'react';
import ReactDOM from 'react-dom';
import { createDashboard } from '@refract-cms/dashboard';
import { config } from '../config/config';
import { constants } from '../shared/constants';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from './theme';
import './styles.css';
import { BrowserRouter, Redirect, Switch, Route } from 'react-router-dom';

const serverUrl = constants.refractPath;

const Dashboard = createDashboard({
  config,
  serverUrl,
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <BrowserRouter>
      <Switch>
        <Redirect exact from="/" to="/admin" />
        <Route path="/admin" component={Dashboard} />
      </Switch>
    </BrowserRouter>
  </MuiThemeProvider>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}
